import { type Component, markRaw } from "vue";
import { defineStore } from "pinia";

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  callback?: Function;
  componentProps: { [key: string]: any };
  title: string;
  onClose?: Function;
};

const defaultProps = { title: "Nieuw item" };

export const useSidePanelState = defineStore("SidePanel", {
  state: () => ({
    isOpen: false,
    props: defaultProps as Props,
    component: null as Component | null,
  }),

  actions: {
    open(component: Component, props?: Props) {
      this.component = markRaw(component);

      if (props) {
        this.props = props;
      }

      this.isOpen = true;
    },

    close() {
      if (this.props.onClose !== undefined) {
        this.props.onClose();
      }

      this.$reset();
    },
  },
});
